"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostPreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const console_1 = require("@rws-framework/console");
const component_2 = require("@front/layouts/default-layout/component");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="cost-preview-page">
    <div class="row">
      <div class="col-lg-12 col-12 pb-lg-5">
        <div class="mb-2">
          <h1>${'cost.preview.title'.t()}</h1>
          <div class="text-zero top-right-button-container">
            <button @click="${(x, c) => x.back()}" type="button"
              class="top-right-button btn btn-primary btn-lg">
              ${'cost.preview.back'.t()}
            </button>
          </div>
        </div>

        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
          <div class="text-center py-5">
            <app-loader></app-loader>
            <p class="mt-3 text-muted">${'cost.preview.loading'.t()}</p>
          </div>
        `)}

        ${(0, fast_element_1.when)(x => x.usageInfo, (0, fast_element_1.html) `        
          
          <div class="row mb-4">
            
            <div class="col-lg-6 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-4">
                    <i class="simple-icon-calculator mr-2"></i>
                    ${'cost.preview.section.token_usage'.t()}
                  </h5>
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-arrow-right"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'reports.promptTokens'.t()}</small>
                          <strong>${x => { var _a; return x.formatNumber(((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.prompt_tokens) || 0); }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-arrow-left"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'reports.completionTokens'.t()}</small>
                          <strong>${x => { var _a; return x.formatNumber(((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.completion_tokens) || 0); }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-primary text-white">
                            <i class="simple-icon-calculator"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'reports.totalTokens'.t()}</small>
                          <strong class="text-primary">${x => { var _a; return x.formatNumber(((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.total_tokens) || 0); }}</strong>
                        </div>
                      </div>
                    </div>
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.reasoning_tokens; }, (0, fast_element_1.html) `
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-info text-white">
                              <i class="simple-icon-bulb"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'cost.preview.reasoning_tokens'.t()}</small>
                            <strong class="text-info">${x => { var _a; return x.formatNumber(((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.reasoning_tokens) || 0); }}</strong>
                          </div>
                        </div>
                      </div>
                    `)}
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.cached_tokens; }, (0, fast_element_1.html) `
                      <div class="col-md-6 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-success text-white">
                              <i class="simple-icon-clock"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'cost.preview.cached_tokens'.t()}</small>
                            <strong class="text-success">${x => { var _a; return x.formatNumber(((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.cached_tokens) || 0); }}</strong>
                          </div>
                        </div>
                      </div>
                    `)}
                  </div>
                </div>
              </div>
            </div>
            
            
            <div class="col-lg-6 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-4">
                    <i class="simple-icon-wallet mr-2"></i>
                    ${'cost.preview.section.cost_info'.t()}
                  </h5>
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-primary text-white">
                            <i class="simple-icon-wallet"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'reports.cost'.t()}</small>
                          <h4 class="mb-0 text-primary">${x => { var _a; return x.formatCurrency(((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.cost) || 0); }}</h4>
                        </div>
                      </div>
                    </div>
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.upstream_inference_cost; }, (0, fast_element_1.html) `
                      <div class="col-md-12 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-warning text-white">
                              <i class="simple-icon-cloud-upload"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'cost.preview.upstream_cost'.t()}</small>
                            <strong class="text-warning">${x => { var _a; return x.formatCurrency(((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.upstream_inference_cost) || 0); }}</strong>
                          </div>
                        </div>
                      </div>
                    `)}
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-info text-white">
                            <i class="simple-icon-info"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'cost.preview.cost_per_token'.t()}</small>
                          <strong class="text-info">${x => x.getCostPerTokenDisplay()}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-secondary text-white">
                            <i class="simple-icon-tag"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'cost.preview.cost_type'.t()}</small>
                          <strong>${x => { var _a; return ((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.type) || 'cost.preview.type.standard'.t(); }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <div class="row mb-4">
            
            <div class="col-lg-6 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-4">
                    <i class="simple-icon-speedometer mr-2"></i>
                    ${'cost.preview.section.performance'.t()}
                  </h5>
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-primary text-white">
                            <i class="simple-icon-clock"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'cost.preview.response_time'.t()}</small>
                          <strong class="text-primary">${x => { var _a; return x.formatTime((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.response_time); }}</strong>
                        </div>
                      </div>
                    </div>
                    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.response_begin_time) !== undefined; }, (0, fast_element_1.html) `
                      <div class="col-md-12 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-info text-white">
                              <i class="simple-icon-hourglass"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'cost.preview.response_begin_time'.t()}</small>
                            <strong class="text-info">${x => { var _a; return x.formatTime((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.response_begin_time); }}</strong>
                          </div>
                        </div>
                      </div>
                    `)}
                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.response_time; }, (0, fast_element_1.html) `
                      <div class="col-md-12 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-success text-white">
                              <i class="simple-icon-energy"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'cost.preview.efficiency'.t()}</small>
                            <strong class="${x => x.getEfficiencyClass()}">
                              ${x => x.getEfficiencyLabel()}
                              <small>(${x => (x.usageInfo.total_tokens / x.usageInfo.response_time).toFixed(1)} tokens/s)</small>
                            </strong>
                          </div>
                        </div>
                      </div>
                    `)}
                  </div>
                </div>
              </div>
            </div>
            
            
            <div class="col-lg-6 mb-3">
              <div class="card shadow-sm h-100">
                <div class="card-body">
                  <h5 class="card-title text-secondary mb-4">
                    <i class="simple-icon-info mr-2"></i>
                    ${'cost.preview.section.context_info'.t()}
                  </h5>
                  <div class="row">
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-user"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'reports.user'.t()}</small>
                          <strong>${x => { var _a, _b; return ((_b = (_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.user.username) || 'cost.preview.user.unknown'.t(); }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-people"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'avatar.avatar'.t()}</small>
                          <strong>${x => { var _a, _b, _c; return ((_c = (_b = (_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.avatar) === null || _c === void 0 ? void 0 : _c.name) || 'cost.preview.avatar.none'.t(); }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-settings"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'avatar.model'.t()}</small>
                          <strong>${x => { var _a; return ((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.message.used_model) || 'cost.preview.model.unknown'.t(); }}</strong>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-wrench"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'message.used_tools'.t()}</small>
                          <strong>${x => { var _a; return x.formatTools((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.message_tools); }}</strong>
                        </div>
                      </div>
                    </div>
                    ${(0, fast_element_1.when)(x => { var _a; return x.isUserSuperAdmin && ((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.company); }, (0, fast_element_1.html) `
                      <div class="col-md-12 mb-3">
                        <div class="d-flex align-items-center">
                          <div class="flex-shrink-0 mr-3">
                            <div class="icon-circle bg-light text-muted">
                              <i class="simple-icon-organization"></i>
                            </div>
                          </div>
                          <div>
                            <small class="text-muted d-block">${'reports.company'.t()}</small>
                            <strong>${x => { var _a; return (_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.company; }}</strong>
                          </div>
                        </div>
                      </div>
                    `)}                    
                    <div class="col-md-12 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 mr-3">
                          <div class="icon-circle bg-light text-muted">
                            <i class="simple-icon-calendar"></i>
                          </div>
                        </div>
                        <div>
                          <small class="text-muted d-block">${'reports.date'.t()}</small>
                          <strong>${x => { var _a; return x.formatDate((_a = x.usageInfo) === null || _a === void 0 ? void 0 : _a.created_at); }}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `)}

        ${(0, fast_element_1.when)(x => !x.loading && !x.usageInfo, (0, fast_element_1.html) `
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">${'cost.preview.not_found.title'.t()}</h4>
            <p class="mb-0">${'cost.preview.not_found.description'.t()}</p>
          </div>
        `)}
      </div>
    </div>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.cost-preview-page {
  padding: 1rem 0;
}
.cost-preview-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
@media (max-width: 768px) {
  .cost-preview-page .top-right-button-container {
    position: relative;
    margin-top: 1rem;
    text-align: right;
  }
}
.cost-preview-page .icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}
.cost-preview-page .card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  transition: box-shadow 0.15s ease-in-out;
}
.cost-preview-page .card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
.cost-preview-page .card .card-title {
  font-weight: 600;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 0.75rem;
  margin-bottom: 1rem !important;
}
.cost-preview-page .stat-highlight {
  font-size: 1.5rem;
  font-weight: bold;
}
.cost-preview-page .performance-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;
}
.cost-preview-page .performance-badge.excellent {
  background-color: #d4edda;
  color: #155724;
}
.cost-preview-page .performance-badge.good {
  background-color: #d1ecf1;
  color: #0c5460;
}
.cost-preview-page .performance-badge.average {
  background-color: #fff3cd;
  color: #856404;
}
.cost-preview-page .performance-badge.slow {
  background-color: #f8d7da;
  color: #721c24;
}
.cost-preview-page .metric-row {
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.cost-preview-page .metric-row:last-child {
  border-bottom: none;
}
.cost-preview-page .text-zero {
  position: relative;
}
@media (max-width: 768px) {
  .cost-preview-page .row {
    margin: 0;
  }
  .cost-preview-page .col-lg-6 {
    padding: 0.5rem;
  }
  .cost-preview-page .card {
    margin-bottom: 1rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let CostPreview = class CostPreview extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.loading = false;
        this.costId = null;
        this.usageInfo = null;
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN ||
            ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER ||
            ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.costId = this.routeParams.id;
        if (this.costId) {
            await this.loadUsageInfo();
        }
    }
    async loadUsageInfo() {
        var _a, _b;
        if (!this.costId)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.get('reports.get-data', {
                routeParams: { id: this.costId }
            });
            if (response.success && response.data) {
                this.usageInfo = response.data;
            }
            else {
                (_a = this.notifyService) === null || _a === void 0 ? void 0 : _a.notify(response.error || 'cost.preview.error.load_failed'.t(), 'error');
            }
        }
        catch (e) {
            (_b = this.notifyService) === null || _b === void 0 ? void 0 : _b.notify('cost.preview.error.load_failed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 5
        }).format(amount || 0);
    }
    formatNumber(num) {
        return new Intl.NumberFormat('en-US').format(num || 0);
    }
    formatDate(date) {
        const dateObj = new console_1.DateUtils(date);
        return dateObj.format('dd-MM-yyyy HH:mm:ss');
    }
    formatTime(seconds) {
        if (!seconds)
            return 'cost.preview.time.not_available'.t();
        if (seconds < 1) {
            return `${(seconds * 1000).toFixed(0)}ms`;
        }
        return `${seconds.toFixed(3)}s`;
    }
    formatTools(tools) {
        // Handle case where tools might be stored as a string or array
        if (typeof tools === 'string') {
            try {
                const parsed = JSON.parse(tools);
                if (Array.isArray(parsed)) {
                    return parsed.map(tool => `tools.${tool.toolName || tool.name || tool}.name`.t()).join(', ');
                }
                return tools;
            }
            catch (_a) {
                return tools;
            }
        }
        if (tools && Array.isArray(tools) && tools.length > 0) {
            return tools.map(tool => `tools.${tool.toolName || tool.name}.name`.t()).join(', ');
        }
        return 'cost.preview.no_tools'.t();
    }
    getEfficiencyLabel() {
        var _a;
        if (!((_a = this.usageInfo) === null || _a === void 0 ? void 0 : _a.response_time))
            return 'cost.preview.efficiency.unknown'.t();
        const tokensPerSecond = this.usageInfo.total_tokens / this.usageInfo.response_time;
        if (tokensPerSecond > 50)
            return 'cost.preview.efficiency.excellent'.t();
        if (tokensPerSecond > 30)
            return 'cost.preview.efficiency.good'.t();
        if (tokensPerSecond > 15)
            return 'cost.preview.efficiency.average'.t();
        return 'cost.preview.efficiency.slow'.t();
    }
    getEfficiencyClass() {
        var _a;
        if (!((_a = this.usageInfo) === null || _a === void 0 ? void 0 : _a.response_time))
            return 'text-muted';
        const tokensPerSecond = this.usageInfo.total_tokens / this.usageInfo.response_time;
        if (tokensPerSecond > 50)
            return 'text-success';
        if (tokensPerSecond > 30)
            return 'text-info';
        if (tokensPerSecond > 15)
            return 'text-warning';
        return 'text-danger';
    }
    getCostPerTokenDisplay() {
        var _a, _b;
        if (!((_a = this.usageInfo) === null || _a === void 0 ? void 0 : _a.cost) || !((_b = this.usageInfo) === null || _b === void 0 ? void 0 : _b.total_tokens))
            return '-';
        const costPerToken = this.usageInfo.cost / this.usageInfo.total_tokens;
        return `$${(costPerToken * 1000).toFixed(6)}/1K tokens`;
    }
    back() {
        component_1.SiteMenu.goto.bind(this)('/reports/cost');
    }
};
exports.CostPreview = CostPreview;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CostPreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostPreview.prototype, "costId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IUsageInfo !== "undefined" && backendImport_1.IUsageInfo) === "function" ? _b : Object)
], CostPreview.prototype, "usageInfo", void 0);
exports.CostPreview = CostPreview = __decorate([
    (0, client_1.RWSView)('cost-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], CostPreview);
CostPreview.defineComponent();
